var map = {
	"./about/grid-left.png": 97,
	"./about/grid-right.png": 98,
	"./about/logo-armani.png": 99,
	"./about/logo-bbc.png": 100,
	"./about/logo-dan.png": 101,
	"./about/logo-getty.png": 102,
	"./about/logo-google.png": 103,
	"./about/logo-ou.png": 104,
	"./about/logo-oxp.png": 105,
	"./about/logo-ubisoft.png": 106,
	"./about/logo-wef.png": 107,
	"./c-home__section--dark_pattern.png": 108,
	"./c-home__section--light_pattern.png": 109,
	"./casestudies/armani-smartwatch.jpg": 110,
	"./casestudies/armani.jpg": 111,
	"./casestudies/fabricius.jpg": 112,
	"./casestudies/getty-events.jpg": 113,
	"./casestudies/gic.jpg": 114,
	"./casestudies/hieroglyphics-initiative.jpg": 115,
	"./casestudies/imperial.jpg": 116,
	"./casestudies/john-lewis-storybook.jpg": 117,
	"./casestudies/mercedes-4matic.jpg": 118,
	"./casestudies/play-with-oreo.jpg": 119,
	"./casestudies/smallfoot.jpg": 120,
	"./casestudies/storycastle.jpg": 121,
	"./casestudies/the-order.jpg": 122,
	"./casestudies/winter-olympics.jpg": 123,
	"./casestudies/zeitgeist-minds.jpg": 124,
	"./casestudy/armani-smartwatch/challenge.png": 125,
	"./casestudy/armani-smartwatch/hero.jpg": 126,
	"./casestudy/armani-smartwatch/solution.jpg": 127,
	"./casestudy/armani/callout_1.jpg": 128,
	"./casestudy/armani/callout_2.jpg": 129,
	"./casestudy/armani/callout_3.jpg": 130,
	"./casestudy/armani/callout_4.jpg": 131,
	"./casestudy/armani/callout_5.jpg": 132,
	"./casestudy/armani/challenge.jpg": 133,
	"./casestudy/armani/hero.jpg": 134,
	"./casestudy/armani/solution.jpg": 135,
	"./casestudy/fabricius/callout_1.jpg": 136,
	"./casestudy/fabricius/callout_2.gif": 137,
	"./casestudy/fabricius/callout_3.jpg": 138,
	"./casestudy/fabricius/challenge.jpg": 139,
	"./casestudy/fabricius/hero.jpg": 140,
	"./casestudy/fabricius/solution.jpg": 141,
	"./casestudy/getty-events/callout_1.jpg": 142,
	"./casestudy/getty-events/callout_2.jpg": 143,
	"./casestudy/getty-events/callout_3.jpg": 144,
	"./casestudy/getty-events/challenge.jpg": 145,
	"./casestudy/getty-events/hero.jpg": 146,
	"./casestudy/getty-events/solution.jpg": 147,
	"./casestudy/gic/callout_1.jpg": 148,
	"./casestudy/gic/callout_2.jpg": 149,
	"./casestudy/gic/callout_3.jpg": 150,
	"./casestudy/gic/challenge.png": 151,
	"./casestudy/gic/hero.jpg": 152,
	"./casestudy/gic/solution.png": 153,
	"./casestudy/hieroglyphics-initiative/callout_1.jpg": 154,
	"./casestudy/hieroglyphics-initiative/callout_2.jpg": 155,
	"./casestudy/hieroglyphics-initiative/callout_3.jpg": 156,
	"./casestudy/hieroglyphics-initiative/challenge.jpg": 157,
	"./casestudy/hieroglyphics-initiative/hero.jpg": 158,
	"./casestudy/hieroglyphics-initiative/solution.png": 159,
	"./casestudy/imperial/callout_1.jpg": 160,
	"./casestudy/imperial/callout_2.jpg": 161,
	"./casestudy/imperial/callout_3.jpg": 162,
	"./casestudy/imperial/challenge.png": 163,
	"./casestudy/imperial/hero.jpg": 164,
	"./casestudy/imperial/solution.png": 165,
	"./casestudy/john-lewis-storybook/challenge.jpg": 166,
	"./casestudy/john-lewis-storybook/hero.jpg": 167,
	"./casestudy/mercedes-4matic/callout_1.jpg": 168,
	"./casestudy/mercedes-4matic/callout_2.jpg": 169,
	"./casestudy/mercedes-4matic/callout_3.jpg": 170,
	"./casestudy/mercedes-4matic/challenge.jpg": 171,
	"./casestudy/mercedes-4matic/hero.jpg": 172,
	"./casestudy/mercedes-4matic/solution.png": 173,
	"./casestudy/play-with-oreo/callout_1.jpg": 174,
	"./casestudy/play-with-oreo/callout_2.jpg": 175,
	"./casestudy/play-with-oreo/callout_3.jpg": 176,
	"./casestudy/play-with-oreo/challenge.jpg": 177,
	"./casestudy/play-with-oreo/hero.jpg": 178,
	"./casestudy/play-with-oreo/solution.jpg": 179,
	"./casestudy/smallfoot/challenge.png": 180,
	"./casestudy/smallfoot/hero.jpg": 181,
	"./casestudy/storycastle/challenge.jpg": 182,
	"./casestudy/storycastle/hero.jpg": 183,
	"./casestudy/the-order/callout_1.jpg": 184,
	"./casestudy/the-order/callout_2.jpg": 185,
	"./casestudy/the-order/callout_3.jpg": 186,
	"./casestudy/the-order/challenge.jpg": 187,
	"./casestudy/the-order/hero.jpg": 188,
	"./casestudy/the-order/solution.jpg": 189,
	"./casestudy/winter-olympics/callout_1.jpg": 190,
	"./casestudy/winter-olympics/callout_2.jpg": 191,
	"./casestudy/winter-olympics/callout_3.jpg": 192,
	"./casestudy/winter-olympics/challenge.png": 193,
	"./casestudy/winter-olympics/hero.jpg": 194,
	"./casestudy/winter-olympics/solution.png": 195,
	"./chatbots/bottom-image-mobile.png": 28,
	"./chatbots/bottom-image.png": 27,
	"./chatbots/hero.jpg": 196,
	"./favicons/favicon.png": 197,
	"./shares/default.jpg": 198,
	"./shares/facebook.jpg": 199,
	"./svgs/icon-armani.svg": 29,
	"./svgs/icon-arrow-left.svg": 30,
	"./svgs/icon-arrow-right.svg": 31,
	"./svgs/icon-close.svg": 32,
	"./svgs/icon-facebook.svg": 33,
	"./svgs/icon-getty.svg": 34,
	"./svgs/icon-google.svg": 35,
	"./svgs/icon-harpercollins.svg": 36,
	"./svgs/icon-imperial.svg": 37,
	"./svgs/icon-instagram.svg": 38,
	"./svgs/icon-john-lewis.svg": 39,
	"./svgs/icon-linkedin.svg": 40,
	"./svgs/icon-mail.svg": 41,
	"./svgs/icon-map.svg": 42,
	"./svgs/icon-mercedes.svg": 43,
	"./svgs/icon-olympics.svg": 44,
	"./svgs/icon-oreo.svg": 45,
	"./svgs/icon-phone.svg": 46,
	"./svgs/icon-playstation.svg": 47,
	"./svgs/icon-twitter.svg": 48,
	"./svgs/icon-ubisoft.svg": 49,
	"./svgs/icon-warner-bros.svg": 50,
	"./svgs/icon-zeitgeist.svg": 51,
	"./svgs/logo-full.svg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;